import { adminHttpClient } from '../../../../../commons/adminHttpClient'

export interface ProductClassDesignSummaryResponse {
  eligibleExpenseCategories: EligibleExpenseCategory[]
  waitingPeriod: number
  totalAllowance: number | string
  offerSameAllowance: boolean
}

export interface EligibleExpenseCategory {
  expenseCategoryId: number
  expenseCategoryName: string
  allowance: number
  allowanceFrequency: number
  eligibleExpenseTypes: EligibleExpenseType[]
  startDate: Date
  endDate: string
  isPerkContinuous: boolean
}

export interface EligibleExpenseType {
  id: number
  name: string
}

const getProductClassDesignSummary = (productClassId: string): Promise<ProductClassDesignSummaryResponse> => {
  return adminHttpClient.get(`/AdminDashboard/Perks/ClassDesign/ProductClassDesignSummary/${productClassId}`)
}

export default getProductClassDesignSummary
